import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const SurveyRuleQuestionOptionCodeValueOptionModel = types.model(
  "SurveyRuleQuestionOptionCodeValueOptionModel",
  {
    type: types.literal("QUESTION_OPTION_CODE"),
    questionOptionCodes: types.array(types.string),
  },
);

export const SurveyRuleRespondentColumnTooManyUniqueValuesModel = types.model(
  "SurveyRuleRespondentColumnTooManyUniqueValuesModel",
  {
    type: types.literal("TOO_MANY_UNIQUE_VALUES"),
  },
);

export const SurveyRuleRespondentColumnUniqueValuesModel = types.model(
  "SurveyRuleRespondentColumnUniqueValuesModel",
  {
    type: types.literal("UNIQUE_VALUES"),
    values: types.array(types.string),
  },
);

export const SurveyRuleRespondentColumnValueOptionModel = types.model(
  "SurveyRuleRespondentColumnValueOptionModel",
  {
    type: types.literal("RESPONDENT_COLUMN_VALUE"),
    valueType: types.union(
      SurveyRuleRespondentColumnTooManyUniqueValuesModel,
      SurveyRuleRespondentColumnUniqueValuesModel,
    ),
  },
);

export const SurveyRuleValueOptionModel = types.union(
  SurveyRuleQuestionOptionCodeValueOptionModel,
  SurveyRuleRespondentColumnValueOptionModel,
);

export const createSurveyRuleValueOptionModel = (
  surveyRuleValueOption: SnapshotIn<typeof SurveyRuleValueOptionModel>,
): Instance<typeof SurveyRuleValueOptionModel> =>
  SurveyRuleValueOptionModel.create(surveyRuleValueOption);
